import { useGigPageContext } from '@fiverr-private/gig_page_context';

export const useSellerHourlyEligibility = () => {
    const { seller } = useGigPageContext();
    const { isPro, isAgency, sellerHourlyEligibility, hourlyRate } = seller || {};

    if (!hourlyRate) {
        return false;
    }
    if (sellerHourlyEligibility !== undefined) {
        return sellerHourlyEligibility;
    }

    return !!isPro || !!isAgency;
};
